import { normalizeMaterialName } from "./materialNames";

const inventoryNumber = new Intl.NumberFormat("en-GB", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// Format only at render time; inventory calculations keep their full precision.
export function formatInventoryNumber(value) {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  return Number.isFinite(number) ? inventoryNumber.format(number) : "—";
}

const inventoryCollator = new Intl.Collator(["en", "ar"], { sensitivity: "base", numeric: true });
export const compareInventoryLabels = (a, b) => inventoryCollator.compare(String(a ?? "").trim(), String(b ?? "").trim());

// Keep each material together, then order its blocks by code (A2 before A10).
export function compareInventoryRows(a, b) {
  return compareInventoryLabels(normalizeMaterialName(a.materialName ?? a.material), normalizeMaterialName(b.materialName ?? b.material))
    || compareInventoryLabels(a.codeLabel ?? a.code, b.codeLabel ?? b.code)
    || compareInventoryLabels(a.blockId ?? a.block_id, b.blockId ?? b.block_id)
    || compareInventoryLabels(a.dist?.id, b.dist?.id);
}

export function matchesInventorySearch(row, query) {
  const search = normalizeMaterialName(query);
  return !search || [row.materialName ?? row.material, row.codeLabel ?? row.code]
    .some(value => normalizeMaterialName(value).includes(search));
}

// Availability can be zero because of reservations. Only physical depletion is sold out.
export function isInventorySoldOut(row) {
  return row.slabs !== null && row.slabs !== undefined && row.slabs !== ""
    && Number.isFinite(Number(row.slabs)) && Number(row.slabs) <= 0;
}
